import { Button, Grid2, Typography } from '@mui/material'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI'
import { AsterChip } from 'asterX-UI/Chip'
import { UserInfo } from 'asterX-UI/DataDisplay'
import { ArrowLeftIcon } from 'asterX-UI/Icons'
import { PlusSquareIcon } from 'asterX-UI/Icons/PlusSquareIcon'
import CreateLoanApplicationModal from 'components/ClientModal/CreateLoanApplicationModal'
import PageContainer from 'components/PageContainer/PageContainer'
import { CollateralTab } from 'components/PageTabs/CollateralTab'
import { useContractStore } from 'context/ContractStore'
import { getFullName, getPledgeName, getTypeName } from 'lib/utils'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { HOME_PATH } from 'routes/constants.routes'

const Collateral = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const id = location.pathname.split('/').pop()

  const {
    contractStore: { collateral },
    contractStoreFunc: { getCollateralById }
  } = useContractStore()

  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (id) {
      getCollateralById(id)
    }
  }, [id])

  return (
    <PageContainer>
      <Grid2 size={{ xs: 12 }}>
        <Button size="small" onClick={() => navigate(HOME_PATH)} sx={{ display: 'flex', gap: '4px' }}>
          <ArrowLeftIcon />
          Назад
        </Button>
      </Grid2>
      <Grid2 container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid2>
          <Typography sx={{ fontSize: 14, color: GRAY_COLORS[600] }}>23.09.2024</Typography>
          <Typography sx={{ fontSize: 24, fontWeight: 600, color: GRAY_COLORS[900] }}>
            {getPledgeName(collateral)}
          </Typography>
        </Grid2>
        <Grid2>
          <UserInfo
            fullName={getFullName(
              collateral?.clientGuarantee?.firstName,
              collateral?.clientGuarantee?.lastName,
              collateral?.clientGuarantee?.patronymic
            )}
            phone={collateral?.clientGuarantee?.mobilePhone1?.toString()?.toPhone()}
          />
        </Grid2>
      </Grid2>

      <Grid2 container justifyContent="space-between" alignItems="center">
        <Grid2 display="flex" gap={2}>
          <AsterChip label={collateral?.loanApplicationId} variant="outlined" sx={{ color: INFO_COLORS[700] }} />
          <AsterChip label={getTypeName(collateral?.type)} variant="outlined" />
        </Grid2>

        <Grid2 display="flex" gap={2}>
          {/* <Button variant="grayText">
            <EditIcon />
            Редактировать
          </Button> */}
          <Button
            variant="contained"
            sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
            onClick={() => setIsModalOpen(true)}
          >
            <PlusSquareIcon />
            Создать заявку
          </Button>
        </Grid2>
      </Grid2>

      <Grid2 container display="flex" flexDirection="column" gap="12px" marginTop="12px">
        <CollateralTab page={'collateral'} />
      </Grid2>
      <CreateLoanApplicationModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        clientGuarantee={collateral?.clientGuarantee}
      />
    </PageContainer>
  )
}

export default Collateral
